/* styled-components & other non-external style-related exports (like, say, a `headerHeight` var) go here */
import { colors, font } from '@chegg-ui/theme';
import { CaretIcon, ChevronIcon, LanguageIcon } from '@chegg-ui/horizon-icons';
import { Listbox } from '@chegg-ui/listbox';
import { Modal } from '@chegg-ui/modal';
import { Typography } from '@chegg-ui/typography';
import styled from 'styled-components'; // this is an example styled-component export, replace with your own needed styles

export var LanguageSelectorContainer = styled.div.withConfig({
  componentId: "sc-zkso47-0"
})(["margin:0;font-family:", ";"], font.family["default"]);
export var LangSelectorWrapper = styled.button.withConfig({
  componentId: "sc-zkso47-1"
})(["display:flex;background-color:transparent;border:none;cursor:pointer;margin:0;padding:0;"]);
export var SelectorLanguageIcon = styled(LanguageIcon).withConfig({
  componentId: "sc-zkso47-2"
})([""]);
export var ActiveLocale = styled(Typography).withConfig({
  componentId: "sc-zkso47-3"
})(["margin:3px 4px;color:", ";"], colors.grey900);
export var CaretArrow = styled(CaretIcon).withConfig({
  componentId: "sc-zkso47-4"
})(["padding:0px 2.8px;margin-top:3.5px;margin-bottom:4px;"]);
export var ChevronArrow = styled(ChevronIcon).withConfig({
  componentId: "sc-zkso47-5"
})(["padding:0px 2px;margin-top:4px;margin-bottom:4px;"]);
export var StyledListbox = styled(Listbox).withConfig({
  componentId: "sc-zkso47-6"
})(["position:relative;box-shadow:none;border:1px solid transparent;padding:8px 1px;[role='listbox']{color:", ";tabindex:0;}"], colors.grey900);
export var StyledSelector = styled.div.withConfig({
  componentId: "sc-zkso47-7"
})([""]);
export var StyledModal = styled(Modal).withConfig({
  componentId: "sc-zkso47-8"
})(["padding:0px ", ";"], font.size.px24);